import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * 記録データのタグ情報を更新するためのAPI呼び出しを行う。
 *
 * @param {string} apiToken - API通信に使用するトークン。
 * @param {Object} options - 更新するタグ情報を含むオブジェクト。リクエストパラメータに使用する
 * @returns {Function} Redux dispatch関数
 */
const updateWorkRecordTags = (apiToken, options) => dispatch => {
  consolelog('[API CALL] updateWorkRecordTags()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_UPDATE_WORK_RECORD_TAGS;
  const { cancelToken, cancelTokenKey } = createCancelToken(
    'updateWorkRecordTags',
  );
  const params = {
    cancelToken,
    ...options,
  };
  return axios
    .post(url, params)
    .then(() => {
      delCancelToken(cancelTokenKey);
      dispatch({
        type: actionTypes.SUCCESS_UPDATE_WROKRECORD_TAG,
      });
    })
    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    })
    .finally(() => {
      dispatch({ type: 'CLOSE_EDIT_MASTER_DIALOG' });
    });
};

export default updateWorkRecordTags;
